import { useAuth0User } from './useAuth0User';
import { getLastUsedOrgId } from './useLastUsedOrgId';

// Auth0 org the PIN cache is scoped to: the session's org, or the remembered login org when logged out
export const usePinOrgId = (): string | undefined => {
  const auth0User = useAuth0User();
  return (auth0User.isAuthenticated ? auth0User.org_id : undefined) ?? getLastUsedOrgId() ?? undefined;
};
